<template>
    <div class="bg-indigo-50 p-5 rounded">
        <div class="font-bold">Промежуток времени</div>
        <div class="mt-2">
            с <input type="time" v-model="start"
                     min="00:00" max="23:59" required>

            по <input type="time" v-model="end"
                      min="00:00" max="23:59" required>

            <div class="w-6/12 mt-6">
                <vue-select v-if="timezones.length > 0 && selected" v-model="selected" :list="this.timezones" title="Таймзона">
                    <option v-for="tz in timezones" :selected="selected.id === tz.id" v-bind:value="tz.name">{{ tz.label }}</option>
                </vue-select>
            </div>
        </div>
    </div>
</template>

<script>

import VueSelect from "../../../../common/VueSelect.vue";

export default {
    components: {
        VueSelect
    },

    props: {
        modelValue: {
            required: true
        }
    },

    data() {
        return {
            start: "08:00",
            end: "20:00",
            timezones: [],
            selected: null
        };
    },

    watch: {
        start() {
            this.updateModelValue()
        },
        end() {
            this.updateModelValue()
        },
        selected() {
            this.updateModelValue()
        }
    },

    methods: {
        updateModelValue() {
            if (!this.selected) {
                return
            }

            this.$emit('update:modelValue', {
                from: this.start,
                to: this.end,
                timezone: this.selected.name,
            })
        }
    },

    mounted() {
        this.start = this.modelValue.from ?? "08:00"
        this.end = this.modelValue.to ?? "20:00"

        axios.get('/api/timezones')
            .then((response) => {
                this.timezones = response.data

                const clientTz = this.modelValue.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone

                this.timezones.forEach(tz => {
                    if (tz.name === clientTz) {
                        this.selected = tz
                    }
                })
            });
    }
}
</script>
